import { ExpenseAccountItem } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 2340. 費用科目一覧
 * [GET] /expense_account_items
 */
const expenseAccountItems = (): Promise<ExpenseAccountItem[]> => {
  return axios.get(`/api/expense_account_items`);
};

export const useExpenseAccountItems = () => {
  return useQuery({
    queryKey: ['expense_account_items'],
    queryFn: () => expenseAccountItems(),
  });
};
